import type { Capability } from "@/types/content";
import { StatusBadge } from "./StatusBadge";
import { Keycap, type KeycapState } from "./keycap/Keycap";
import "./CapabilityCard.css";

const keycapStateFor: Record<Capability["status"], KeycapState> = {
  live: "active",
  pilot: "active",
  "in-development": "default",
  planned: "unavailable",
};

/**
 * Presents a product capability as the key that represents it.
 *
 * The key carries the identity, the badge carries the honest development
 * status, and the description stays on the page rather than being revealed on
 * hover — these statuses are the site's most load-bearing claims and should
 * never be reachable by pointer only.
 */
export function CapabilityCard({ capability }: { capability: Capability }) {
  return (
    <article className="capability-card">
      <div className="capability-card-head">
        <Keycap id={capability.keycap} size="lg" state={keycapStateFor[capability.status]} />
        <StatusBadge status={capability.status} />
      </div>
      <h3 className="capability-card-title">{capability.title}</h3>
      <p className="capability-card-description">{capability.description}</p>
    </article>
  );
}
